export namespace Url {
  export const SLASH_ROUTE = '/';
  export const ERR_404 = '404';
}
